// extracted by mini-css-extract-plugin
module.exports = {"makeClaim":"InsuranceInfo_makeClaim__3ysuB"};